import React from "react";
import {MessageContext} from "./ChatInputProvider";

const withChatInput = (WrappedComponent) => {
    const WithChatInput = (props) => {
        const context = React.useContext(MessageContext);
        const setChatInput = (input) => {
            context.setText(input);
        };

        const getChatInput = () => {
            return context.text;
        };

        return (
            <WrappedComponent
                {...props}
                chatInput={{
                    getChatInput,
                    setChatInput,
                }}
            />
        );
    };

    return WithChatInput;
};

export default withChatInput;
